export default "__VITE_ASSET__CXJ6DK2o__"